/**
 * Single source of truth for a tester's display color, used wherever a UI
 * needs to color an avatar / ring / badge for a tester.
 *
 * History: `tester_profiles.color` was a stored, admin-pickable brand color
 * until #660 removed it (migration `20260205220000_remove_tester_color.sql`)
 * because it added complexity without value. We now derive a stable color
 * deterministically from the tester's alias so the same tester always reads
 * the same color across every surface (web dialog header + kebab ring,
 * discord-activity profile modal avatar, …) with no storage cost.
 *
 * The palette is brand-adjacent so the derived colors read as intentional
 * rather than random.
 */
const FALLBACK_PALETTE = [
    '#BDE039', // brand primary
    '#7FB069', // moss
    '#5BA3D0', // sky
    '#D08B5B', // copper
    '#B05B7F', // rose
    '#7F5BB0', // lilac
];
export function deriveTesterColor(alias) {
    let hash = 0;
    for (let i = 0; i < alias.length; i++) {
        hash = (hash * 31 + alias.charCodeAt(i)) | 0;
    }
    const index = Math.abs(hash) % FALLBACK_PALETTE.length;
    return FALLBACK_PALETTE[index];
}
//# sourceMappingURL=derive-color.js.map